import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/PeticionMaterial/peticionmaterial';
import PeticionesMpendientes from './PMpendientes';

const mstp = state => {
    return {...state.peticionM}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(PeticionesMpendientes)
